export const yieldAndManagementDict = {
  en: {
    perYear: '',
  },
  de: {
    perYear: '',
  },
  ru: {
    perYear: 'в год',
  },
  tr: {
    perYear: '',
  },
  es: {
    perYear: 'por año',
  },
};
